export default __webpack_public_path__ + "static/castings-b6caa662eb867ba096294d1a65437bbb.png";